import {Migration} from '@mydocma/core/src/lib/migration';
import {IDBPDatabase} from 'idb';
import {MmProjectDbCollections} from '../../mm-project-db-schema';

export const V13: Migration = {

  up(database: IDBPDatabase<unknown>) {
    database.deleteObjectStore(MmProjectDbCollections.fault_patches_backup);
  },

};
